export enum PostType {
  POST = "post",
  REEL = "reel",
  VIDEO = "video",
  SHORT = "short",
}
